export default __webpack_public_path__ + "static/media/next.2a5dce78.svg";